import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
    // component: () => import('../views/tools/tz-calculator/index.vue')
  },
  {
    path: '/tools/tz_calculator',
    name: 'TzCalculator',
    component: () => import('../views/tools/tz-calculator/index.vue')
  }
]

const router = new VueRouter({
  base: '/spa/',
  routes
})

export default router
